import { faWikipediaW } from '@fortawesome/free-brands-svg-icons';
import {
	faLanguage,
	faListAlt,
	faQuestionCircle,
} from '@fortawesome/free-solid-svg-icons';

export const widgetOptions = [
	{ label: 'accordion', icon: faQuestionCircle },
	{ label: 'dropdown', icon: faListAlt },
	{ label: 'translate', icon: faLanguage },
	{ label: 'wikisearch', icon: faWikipediaW },
];
